import styled from 'styled-components';

export const Container = styled.div`
  .hefesto-modal__container {
    margin-bottom: 1rem;
  }
`;
